export const VNROUTES_SET_ROUTE = 'VNROUTES_SET_ROUTE'
export const VNROUTES_CLEAR_ROUTE = 'VNROUTES_CLEAR_ROUTE'
